import PaymentScheduleMobile from './PaymentScheduleMobile/PaymentScheduleMobile';
import PaymentScheduleTableView from './paymentScheduleTableView/paymentScheduleTableView';

import UnavailableJSON from '../../assets/animation-json/noDataFound.json';
import ViewAssetsButton from '../EquipmentViewPopup/ViewAssetsButton/ViewAssetsButton';

import {Accordion} from '@deere/fuel-react';
import Lottie from 'lottie-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import PaymentScheduleCountryProduct from './PaymentScheduleCountryProduct.json';
import './scheduleInstallments.css';

const ScheduleInstallments = ({
  schedulePayments,
  fields,
  currentContractYear,
  allContractView,
  displayPagination,
  selectedContractNumber,
  showAssets,
  hideTitle,
  country,
}) => {
  const [isMobile, setIsMobile] = React.useState(false);
  const {t} = useTranslation();

  const checkIsMobile = () => {
    setIsMobile(window.innerWidth <= 950);
  };

  React.useEffect(() => {
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);

  const renderPaymentSchedule = (ProductType, index) => {
    if (!schedulePayments[ProductType].length) {
      return null;
    }

    if (isMobile) {
      return (
        <div
          className="PaymentScheduleMobileWrapper"
          data-testid="PaymentScheduleMobile"
        >
          {schedulePayments[ProductType].map((scheduled) => (
            <PaymentScheduleMobile
              schedulePayments={scheduled}
              key={`${ProductType}-${scheduled.scheduleType}`}
              ProductType={ProductType}
              country={country}
              allfields={PaymentScheduleCountryProduct[country][ProductType]}
            />
          ))}
        </div>
      );
    } else if (country && ProductType) {
      return (
        <Accordion id="payment-installment-overview">
          <PaymentScheduleTableView
            allContractView={allContractView}
            ProductType={ProductType}
            schedulePayments={schedulePayments[ProductType]}
            index={index}
            selectedContractNumber={selectedContractNumber}
            country={country}
            headCells={
              allContractView
                ? PaymentScheduleCountryProduct[country][ProductType]
                : PaymentScheduleCountryProduct[country][ProductType].filter(
                    (item) => item !== 'CONTRACT_NUMBER'
                  )
            }
          />
        </Accordion>
      );
    } else {
      return null;
    }
  };

  return (
    <div className="scheduleInstallmentsWrapper">
      {!hideTitle && (
        <div className="paymentScheduleHeading">
          {t('SCHEDULE_INSTALLMENTS')}
          {!allContractView && showAssets && (
            <ViewAssetsButton selectedContractNumber={selectedContractNumber} />
          )}
        </div>
      )}
      {schedulePayments && Object.keys(schedulePayments).length ? (
        Object.keys(schedulePayments).map((ProductType, index) => (
          <div key={`scheduled-${ProductType}`}>
            {renderPaymentSchedule(ProductType, index)}
          </div>
        ))
      ) : (
        <div className="no-contract" data-testid="no-contract">
          <div className="no-contract-wrapper">
            <div className="no-contract-image">
              <Lottie animationData={UnavailableJSON} loop={true} />
            </div>
            <div className="no-contract-text">
              <div className="nocontract-heading">
                {t('NO_PAYMENTS_TO_DISPLAY')}
              </div>
              <div className="nocontract-subheading">
                {t('YOU_HAVE_NO_PAYMENT_SCHEDULE_FOR_THE_SELECTED_FILTER')}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  paymentScheduleLoader: state.appStates.paymentScheduleLoader,
  country: state.appStates.allContracts?.countryCode,
});

export default connect(mapStateToProps)(ScheduleInstallments);
